var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('i-col',{attrs:{"span":"24"}},[_c('div',{staticClass:"container fs-18"},[_c('div',{staticClass:"background-orange"}),_c('div',{staticClass:"contents margin-left-20 padding-5"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }